import { ChangePasswordFormValues, PaymentMethod, User } from "../types"
import { Action, Dispatch } from "redux"
import { PAYMENT_METHODS_ACTION, SECURITY_ACTION } from "./types"
import { handleAuthorizedRequest, me, paymentMethods, users } from "../apis"
import { mapListToCamelCase, mapToCamelCase, mapToSnakeCase } from "../utility"
import { toast } from "react-toastify"
import { successFilledToastOptions } from "../constants"
import { AUTH_ACTION } from "./loginActions"
import { lang } from "../constants/languages"

export const changePassword = (formValues: ChangePasswordFormValues) => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await users("/password/", "put", mapToSnakeCase(formValues))
      toast.success(lang.account.profile.change_password_form.success.success_message, successFilledToastOptions)

      dispatch({
        type: SECURITY_ACTION.CHANGE_PASSWORD,
        dispatch: null
      })
    },
    lang.account.profile.change_password_form.error.error_on_change_password,
    dispatch
  )
}

export const fetchUserData = () => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await me("/", "get")
      localStorage.setItem("user", JSON.stringify(mapToCamelCase(response.data)))
      dispatch({
        type: AUTH_ACTION.UPDATE_USER,
        payload: mapToCamelCase(response.data)
      })
    },
    "Fetching user has error.",
    dispatch
  )
}

export const saveUserData = (user: User) => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await users(`/${user.id}/`, "put", mapToSnakeCase(user))
      dispatch({
        type: AUTH_ACTION.UPDATE_USER,
        payload: user
      })
      toast.success(lang.account.profile.success_data_save, successFilledToastOptions)
    },
    lang.account.profile.error.error_on_saving_user,
    dispatch
  )
}

export const saveUserProfilePhoto = (photo: FormData) => async (dispatch: Dispatch<Action>) => {
  return await handleAuthorizedRequest(
    async () => {
      const response = await users(`/upload_photo/`, "put", photo)

      dispatch({
        type: AUTH_ACTION.UPLOAD_PROFILE_PHOTO,
        payload: response.data.photo
      })
      toast.success(lang.account.profile.success_picture_upload, successFilledToastOptions)
    },
    lang.account.profile.error.error_on_uploading_picture,
    dispatch
  )
}

export const fetchPaymentMethods = (userId?: number) => async (dispatch: Dispatch<Action>) => {
  const url = userId ? `/?user_id=${userId}` : "/"
  await handleAuthorizedRequest(
    async () => {
      const response = await paymentMethods(url, "get")
      dispatch({
        type: PAYMENT_METHODS_ACTION.FETCH_PAYMENT_METHODS,
        payload: mapListToCamelCase(response.data.results)
      })
    },
    lang.account.payment_methods.payment_form.error.error_on_fetching,
    dispatch
  )
}

export const createPaymentMethod = (body: PaymentMethod, userId?: number) => async (dispatch: Dispatch<Action>) => {
  const url = userId ? `/?user_id=${userId}` : "/"
  await handleAuthorizedRequest(
    async () => {
      const response = await paymentMethods(url, "post", mapToSnakeCase(body))
      dispatch({
        type: PAYMENT_METHODS_ACTION.ADD_PAYMENT_METHOD,
        payload: mapToCamelCase(response.data)
      })
      toast.success(lang.account.payment_methods.payment_form.success.success_on_create, successFilledToastOptions)
    },
    lang.account.payment_methods.payment_form.error.error_on_create,
    dispatch
  )
}

export const deletePaymentMethod = (id: number) => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await paymentMethods(`/${id}/`, "delete")
      if (response.status === 204) {
        dispatch({
          type: PAYMENT_METHODS_ACTION.DELETE_PAYMENT_METHOD,
          payload: id
        })
        toast.success(lang.account.payment_methods.success_on_delete, successFilledToastOptions)
      }
    },
    lang.account.payment_methods.error_on_delete,
    dispatch
  )
}

export const updatePaymentMethod = (formValues: PaymentMethod) => async (dispatch: Dispatch<Action>) => {
  await handleAuthorizedRequest(
    async () => {
      const response = await paymentMethods(`/${formValues.id}/`, "put", mapToSnakeCase(formValues))
      dispatch({
        type: PAYMENT_METHODS_ACTION.UPDATE_PAYMENT_METHOD,
        payload: mapToCamelCase(response.data)
      })
      toast.success(lang.account.payment_methods.payment_form.success.success_on_update, successFilledToastOptions)
    },
    lang.account.payment_methods.payment_form.error.error_on_update,
    dispatch
  )
}
